<template>
	<div class="text-left">
		<loading :active.sync="isLoading"></loading>

		<div class="alert" v-if="status > 0">

				<span v-if="status == 200">
					{{ t.form.success }}
				</span>
				<span v-if="status == 401 || status == 403">
					{{ t.error.access_denied_content }}
				</span>
				<span v-if="status == 404">
						{{ t.error.notfound_content_list }}
				</span>
		</div>

		<ul>
			<li v-for="role in roles" class="mb-2">
				<input type="checkbox" v-model="role.d.has" /> <strong>{{ role.d.name }}</strong>
				<ul>
					<li v-for="sub in role.sub" >
						<input type="checkbox" v-model="sub.has" /> {{ sub.name }}
					</li>
				</ul>
			</li>
			<li class="text-right">
				<button class="btn btn-primary" v-on:click="saveRoles">{{ t.save }}</button>
			</li>
		</ul>

	</div>
</template>

<script>
    export default {
        name: 'groupRoles',
        data () {
            return {
                t: this.$root.t,
                roles: null,
                isLoading: false,
                status: 0
            }
        },
        props: {
            uid: {
                type: Number
            }
        },
        mounted () {

            this.fetchUserRoles();
        },
        methods: {
            fetchUserRoles () {

                if (!this.isLoading) {
                    this.isLoading = true;

                    this.$http.get(api+'api/v1/user/groups/roles?id='+this.uid, ).then(
                        response => {

                        this.roles = response.body.result.roles;
                    this.isLoading = false;
                    this.status = (response.status > 200) ? response.status : 0;
                }, response => {
                        this.isLoading = false;
                        this.status = response.status;
                    });
                }

            },
            saveRoles () {
                this.isLoading = true;
                this.$http.post(api+'api/v1/user/groups/roles?id='+this.uid,
                    { roleData: this.roles } ).then(
                    response => {
                    this.status = response.status;
                    this.isLoading = false;

                    }, response => {
                            this.status = response.status;
                            this.isLoading = false;
                    });
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

	li {
		list-style: none;
		padding: 0;
		margin: 0;
	}

	input {
		margin-right: 10px;
	}

</style>



// WEBPACK FOOTER //
// src/components/user/roles/groupRole.vue